<template>
  <!-- Modal for software infos -->
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px"
             top="30vh">
    <div class="confirm-container">
      <div class="confirm-tip">
        <span class="warn">!</span>
        {{ operate==='install'?
        languages.softInstall.installNote: languages.softInstall.uninstallNote }}
      </div>
      <div class="confirm-item">
        <div class="confirm-name">{{ languages.applyConfirm.softname }}:</div>
        <div class="confirm-desc">{{ softname }}</div>
      </div>
      <div class="confirm-info"
           v-if="operate==='install'">
        {{  languages.softInstall.isInstalling }}
        <p>...</p>
      </div>
      <div class="confirm-info"
           v-if="operate==='uninstall'">
        {{languages.softInstall.confirm}}
        <!-- <p>...</p> -->
      </div>
      <div class="confirm-info"
           v-if="operate==='uninstalling'">
        {{ languages.softInstall.isUninstalling  }}
        <p>...</p>
      </div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button v-if="operate === 'uninstalling'"
                 class="button-confirm"
                 type="primary"
                 @click="clearStorage">{{
        languages.softInstall.cancel
      }}</el-button>
      <div v-if="operate === 'install'">
        <el-button v-if="type === 'stop'"
                   class="button-confirm"
                   type="primary"
                   loading>{{
        languages.softInstall.stopping
      }}</el-button>
        <el-button v-else
                   class="button-confirm"
                   type="primary"
                   @click="Stop">{{
        languages.softInstall.stop
      }}</el-button>
      </div>
      <div v-if="operate === 'uninstall'">
        <el-button class="button-cancel"
                   @click="Cancel">{{languages.cancel}}</el-button>
        <el-button class="button-confirm"
                   type="primary"
                   @click="GoUninstall">{{languages.confirm}}</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    languages: Object,
    type: String,
    operate: String,
    show: Boolean,
    softname: String,
  },
  methods: {
    Stop () {
      this.$parent.stopPreInstall(this.type);
    },
    GoUninstall () {
      this.$parent.handleUninstall();
    },
    Cancel () {
      this.$parent.hideConfirmDialog();
    },
    clearStorage () {
      this.$parent.clearPreUninstall();
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-name {
  margin-right: 5px;
}
.confirm-info {
  display: flex;
  white-space: pre-wrap;
  margin-left: 45px;
  margin-right: 20px;
  line-height: 22px;
}
p {
  margin: 3px 0 0 3px;
  display: inline-block;
  height: 1em;
  line-height: 1;
  text-align: left;
  overflow: hidden;
}
p::before {
  display: block;
  content: '. . .\A. .\A.';
  white-space: pre-wrap;
  animation: p 2s infinite step-start both;
}
@keyframes p {
  25% {
    transform: translateY(-3em);
  }
  50% {
    transform: translateY(-2em);
  }
  75% {
    transform: translateY(-1em);
  }
}
</style>
